<template>
    <div class="nav">
        <div v-if="title == 1" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList1" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 2" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList2" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 3" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList3" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 4" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList4" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 5" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList5" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 6" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList6" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 7" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList7" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 8" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList8" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 9" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList9" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 10" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList10" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div v-if="title == 11" class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in policyList11" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Nav',
    props: ['title'],
    data() {
        return {
            policyList: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: 'CMCA介绍'
                },
                {
                    name: '联系方式'
                },
                {
                    name: '列表'
                }
            ],
            policyList1: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '新闻中心'
                }
            ],
            policyList2: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: 'CMCA介绍'
                }
            ],
            policyList3: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: 'CMCA动态'
                }
            ],
            policyList4: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '政策法规'
                }
            ],
            policyList5: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '会议活动'
                }
            ],
            policyList6: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '移动世界'
                }
            ],
            policyList7: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '会员服务'
                }
            ],
            policyList8: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '微信公众号'
                }
            ],
            policyList9: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '最新动态'
                }
            ],
            policyList10: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '推荐阅读'
                }
            ],
            policyList11: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '申请表下载'
                }
            ],
            contactName: '联系方式',
            englishName: 'contact information'
        }
    },
    mounted() {

    },
    beforeCreate() {

    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.nav {
    width: 100%;
    .container {
        width: 1200px;
        margin: 0 auto;
        padding-top: 30px;
        span {
            font-size: 16px;
            font-weight: 400 !important;
            color: #999 !important;
            line-height: 50px;
            cursor: pointer;
            display: block;
            -moz-user-select: none; /* 火狐 */
            -webkit-user-select: none; /* webkit浏览器 */
            -ms-user-select: none; /* IE10 */
            -khtml-user-select: none; /* 早期浏览器 */
        }
        ul {
            list-style: none;
            width: 280px;
            display: flex;
            justify-content: space-between;
            padding-left: 0;
            li {
                font-size: 16px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 30px;
                cursor: pointer;
                -moz-user-select: none; /* 火狐 */
                -webkit-user-select: none; /* webkit浏览器 */
                -ms-user-select: none; /* IE10 */
                -khtml-user-select: none; /* 早期浏览器 */
                padding-left: 4px;
                &:last-child {
                    font-size: 16px;
                    font-weight: 400;
                    color: #333;
                    line-height: 30px;
                }
            }
        }
        .zcfg {
            width: 200px;
        }
        .contact-name {
            font-size: 30px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            width: 100%;
            display: block;
            text-align: center;
            margin-top: 50px;
            margin-bottom: 10px;
        }
        .contact-name-e {
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 30px;
            width: 100%;
            display: block;
            text-align: center;
        }
    }
}
::v-deep .el-breadcrumb__inner {
    font-size: 16px;
    font-weight: 400 !important;
    color: #999 !important;
    line-height: 30px;
}
</style>
